import { render } from "./LinkifiedText.vue?vue&type=template&id=a3f8272a&scoped=true"
import script from "./LinkifiedText.vue?vue&type=script&lang=js"
export * from "./LinkifiedText.vue?vue&type=script&lang=js"

import "./LinkifiedText.vue?vue&type=style&index=0&id=a3f8272a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f8272a"]])

export default __exports__